module.exports = __webpack_public_path__ + "static/media/Icn-pdf.14d0d2ed.svg";